import { BaseRepository } from "repositories/BaseRepository";
export class SyncStateRepository extends BaseRepository {
  constructor(db) {
    super(db, "syncState");
  }
}